import { ApiConsoleValue, PdfOutputType } from "@components/api-playground/types";
import { Paper } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import theme from "@styles/theme";
import React from "react";
import PdfViewer from "@components/api-playground/components/PdfViewer";

const PdfPanel = (props: { apiConsoleValue: ApiConsoleValue; pdf: PdfOutputType }) => {
  const apiConsoleValue = props.apiConsoleValue;
  const pdf = props.pdf;

  const Loading = () => {
    return (
      <div
        style={{
          display: "grid",
          height: "100%",
          width: "100%",
          placeItems: "center",
          backgroundColor: theme.palette.grey[400],
        }}
      >
        <CircularProgress />
      </div>
    );
  };

  const Error = () => {
    return (
      <div style={{ padding: theme.spacing(4) }}>
        <div>Status code: {apiConsoleValue.statusCode}</div>
        <div>{apiConsoleValue.message}</div>
        <div>{JSON.stringify(apiConsoleValue.data)}</div>
      </div>
    );
  };

  const Pdf = () => {
    return <PdfViewer file={pdf.value} />;
  };

  if (pdf.status === "loading") {
    return <Loading />;
  } else if (pdf.status === "error") {
    return <Error />;
  } else {
    return <Pdf />;
  }
};

export default React.memo(PdfPanel);
